import { connect } from "react-redux"
import { Dispatch } from "redux"
import { RootState } from "../../../../reducers"
import { ActionDispatcher } from "../../actiondispacher/action-dispacher"

export interface IContainerProps {
  tags: string[] | null
  actions: ActionDispatcher
}

const mapStateToProps = ({
  pages,
}: RootState): Omit<IContainerProps, "actions"> => ({
  tags: pages.editor.currentEditingState.tags,
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: new ActionDispatcher(dispatch),
})

export const Container = connect(mapStateToProps, mapDispatchToProps)
